export default __webpack_public_path__ + "static/mine-free_small-image_4-519d2a2ffdbc6f34f66269574717a174.png";